module.exports = __webpack_public_path__ + "d2a807ce539d1e1e0ad481f20dc75375.jpg";